import { useDropdownContext } from ".";
import cx from "classnames";
import { useHotkeys } from "react-hotkeys-hook";
import { KeyboardKeys } from "enum/keyboardkeys.enum";
import { mergeRefs } from "utils/react/mergeRefs";
import React from "react";

export const DropdownToggle = ({
  children,
  className,
}: {
  children: React.ReactNode;
  className?: string;
}): JSX.Element => {
  const { mode, onClose, setOpen, isOpen, setTriggerElement } =
    useDropdownContext();

  const ref = useHotkeys(
    KeyboardKeys.ENTER,
    () => {
      isOpen ? onClose() : setOpen();
    },
    {
      enableOnTags: ["INPUT"],
    }
  );

  const mergedRef = React.useMemo(
    () => mergeRefs([ref, setTriggerElement]),
    [ref, setTriggerElement]
  );

  return (
    <div
      className={cx(className, "DropdownToggle focus:bg-yellow-200")}
      ref={mergedRef}
      {...(mode === "onHover" && { onMouseEnter: () => setOpen() })}
      {...(mode === "onHover" && { onMouseLeave: () => onClose() })}
      {...(mode === "onClick" && {
        onClick: (e) => {
          e.stopPropagation();
          isOpen ? onClose() : setOpen();
        },
      })}
    >
      {children}
    </div>
  );
};
